/** Force English HTML5 constraint validation messages (avoids browser locale strings). */
export function setupEnglishFormValidation() {
  document.addEventListener(
    'invalid',
    (e) => {
      const el = e.target
      if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)) {
        return
      }
      if (el.validity.valueMissing) {
        el.setCustomValidity('Please fill in this field.')
      } else if (el.validity.typeMismatch) {
        el.setCustomValidity('Please enter a valid value.')
      } else if (el.validity.tooShort) {
        el.setCustomValidity(`Please enter at least ${el.minLength} characters.`)
      } else if (el.validity.patternMismatch) {
        el.setCustomValidity('Please match the requested format.')
      } else {
        el.setCustomValidity('Please check this field.')
      }
    },
    true
  )

  document.addEventListener(
    'input',
    (e) => {
      const el = e.target
      if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement) {
        el.setCustomValidity('')
      }
    },
    true
  )
}
